
// Create a new observer
// let observer = new IntersectionObserver(function (entries) {
// 	entries.forEach(function (entry) {
// 		// Log if the element and if it's in the viewport
// 		console.log(entry.target);
// 		console.log(entry.isIntersecting);
// 	});
// });

// // The element to observe
// let app = document.querySelector('[data-widget-container-wrapper]');
// console.log(app)
// // Attach it to the observer
// observer.observe(app);

function winLoad(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener("load", callback);
  }
}

winLoad(function () {
  console.log('Window is loaded');
});

// if (document.querySelector('[data-selling_plan]') != 0) {  
//   let widget=setInterval(() => {  
//     let subscription_div=document.querySelector('.rc-option__subsave');
//     if (subscription_div != null) {
//       subscription_div.insertAdjacentHTML('beforeend', document.querySelector('[data-selling_offer]').innerHTML);
//       clearInterval(widget);
//     }
//   }, 100);  
// }



window.showSellingOffer = function () {
  if (window.currentCountry == 'IN' || window.currentCountry == 'US') {
    let coffee_tye = document.querySelector('[data-coffee_type]').getAttribute('data-coffee_type');
    if (coffee_tye == 'coffee' && document.querySelector('[data-type="variant-radios"] .swatch [name="Bag Size"]:checked') != null) {
      let bag_size = document.querySelector('[data-type="variant-radios"] .swatch [name="Bag Size"]:checked').value;
      if (document.querySelector(`[data-selling-offers='${bag_size}']`) != null && document.querySelector(`[data-selling-offers='${bag_size}'] [data-selling_plan]`) != null) {
        let widget = setInterval(() => {
          let subscription_div = document.querySelector('.rc-option__subsave');
          if (subscription_div != null) {
            document.querySelectorAll('[data-option-subsave] [data-selling_plan]').forEach(ele => {
              ele.remove();
            });
            subscription_div.insertAdjacentHTML('beforeend', document.querySelector(`[data-selling-offers='${bag_size}'] [data-selling_offer] `).innerHTML);
            document.querySelector('[data-option-onetime]').addEventListener('click', (e) => {
              e.stopImmediatePropagation();
              window.isSubscription = false;
              window.isOnetime = true;
            })
            document.querySelector('[data-option-subsave]').addEventListener('click', (e) => {
              e.stopImmediatePropagation();
              window.isSubscription = true;
              window.isOnetime = false;
            })
            clearInterval(widget);
          }
        }, 100);
      }
    } else {
      if (document.querySelector(`[data-selling-offers='${coffee_tye}']`) != null && document.querySelector(`[data-selling-offers='${coffee_tye}'] [data-selling_plan]`) != null) {
        let widget = setInterval(() => {
          let subscription_div = document.querySelector('.rc-option__subsave');
          if (subscription_div != null) {
            document.querySelectorAll('[data-option-subsave] [data-selling_plan]').forEach(ele => {
              ele.remove();
            });
            subscription_div.insertAdjacentHTML('beforeend', document.querySelector(`[data-selling-offers='${coffee_tye}'] [data-selling_offer]`).innerHTML);
            document.querySelector('[data-option-onetime]').addEventListener('click', (e) => {
              e.stopImmediatePropagation();
              window.isSubscription = false;
              window.isOnetime = true;
            })
            document.querySelector('[data-option-subsave]').addEventListener('click', (e) => {
              e.stopImmediatePropagation();
              window.isSubscription = true;
              window.isOnetime = false;
            })
            clearInterval(widget);
          }
        }, 100);
      }

      if (coffee_tye.length == 0 && document.querySelector(`[data-selling-offers='null']`) != null && document.querySelector(`[data-selling-offers='null'] [data-selling_plan]`) != null) {
        let widget = setInterval(() => {
          let subscription_div = document.querySelector('.rc-option__subsave');
          if (subscription_div != null) {
            document.querySelectorAll('[data-option-subsave] [data-selling_plan]').forEach(ele => {
              ele.remove();
            });
            subscription_div.insertAdjacentHTML('beforeend', document.querySelector(`[data-selling-offers='null'] [data-selling_offer]`).innerHTML);
            document.querySelector('[data-option-onetime]').addEventListener('click', (e) => {
              e.stopImmediatePropagation();
              window.isSubscription = false;
              window.isOnetime = true;
            })
            document.querySelector('[data-option-subsave]').addEventListener('click', (e) => {
              e.stopImmediatePropagation();
              window.isSubscription = true;
              window.isOnetime = false;
            })
            clearInterval(widget);
          }
        }, 100);
      }
    }
  }

  if (window.currentCountry == 'CA') {
    let bag_size = 'CA';
    if (document.querySelector(`[data-selling-offers='${bag_size}']`) != null && document.querySelector(`[data-selling-offers='${bag_size}'] [data-selling_plan]`) != null) {
      let widget = setInterval(() => {
        let subscription_div = document.querySelector('.rc-option__subsave');
        if (subscription_div != null) {
          document.querySelectorAll('[data-option-subsave] [data-selling_plan]').forEach(ele => {
            ele.remove();
          });
          subscription_div.insertAdjacentHTML('beforeend', document.querySelector(`[data-selling-offers='${bag_size}'] [data-selling_offer] `).innerHTML);
          document.querySelector('[data-option-onetime]').addEventListener('click', () => {
            window.isSubscription = false;
            window.isOnetime = true;
          })
          document.querySelector('[data-option-subsave]').addEventListener('click', () => {
            window.isSubscription = true;
            window.isOnetime = false;
          })
          clearInterval(widget);
        }
      }, 100);
    }
  }

}
window.showSellingOffer();
yotpoButtonHide();
if (document.querySelector('[data-button-type="submit"]') != null) {
  document.querySelector('[data-button-type="submit"]').addEventListener('click', function () {
    yotpoButtonHide();
  })
}

function yotpoButtonHide() {
  let widget = setInterval(() => {
    if (document.querySelector('[total-reviews-search]') != null) {
      if (document.querySelectorAll('[total-reviews-search]').length > 0) {
        if (document.querySelector('[total-reviews-search="0"]')) {
          if (document.querySelector('.write-question-review-button') != null) {
            document.querySelector('.write-question-review-button').classList.add('d-none');
          }
          if (document.querySelector('.bottom-line-items') != null) {
            document.querySelector('.bottom-line-items').classList.add('d-none');
          }
        } else {
          if (document.querySelector('.write-question-review-button') != null) {
            document.querySelector('.write-question-review-button').classList.remove('d-none');
          }
          if (document.querySelector('.bottom-line-items') != null) {
            document.querySelector('.bottom-line-items').classList.remove('d-none');
          }
        }
        clearInterval(widget);
      }
    }
  }, 100);
}

// if (document.querySelector('[data-product_image_slider]') != null) {
//   if (window.innerWidth < 992) {
//     document.querySelector('[data-product_image_slider]').setAttribute('dir','ltr')
//   }
// }
if (document.querySelectorAll('[data-yemen-mocha="12oz"]').length > 0 && document.querySelector('[data-yemen-mocha="12oz"] input').checked != false) {
  document.querySelectorAll('[data-yemen-mocha="12oz"]')[0].click();
}

if (document.querySelector('[data-faq_block]') != null) {
  document.querySelector('[data-pdp_review_section]').innerHTML = document.querySelector('[data-faq_block]').innerHTML;
  document.querySelector('[data-faq_block]').classList.add('d-none');
}

if (window.innerWidth < 800) {
  document.addEventListener("scroll", () => {
    const atcContainer = document.querySelector(".quantity-wrapper-container");
    if (!atcContainer) return;

    const scrollY = window.scrollY;
    const distanceFromBottom = document.documentElement.scrollHeight - window.innerHeight - scrollY;

    if (scrollY > 500 && distanceFromBottom > 1000) {
      atcContainer.classList.add("fixed-ATC-active");
    } else {
      atcContainer.classList.remove("fixed-ATC-active");
    }
  });
}